import type { Component } from "solid-js";
import { cn } from "@/libs/cn";

/**
 * The "Talent Pool — Piano Free" premium lock mark: a dark tertiary disc with a
 * white ring and a gold filled lock. It is the shared paywall affordance across
 * the locked heart on freelancer cards and the locked "Talent pool" tab, so the
 * upsell reads as one system. `class` lets the caller size / position it — a
 * corner badge anchored to the heart, an inline mark on the tab.
 */
export const PremiumLockBadge: Component<{ class?: string }> = (props) => (
  <span
    class={cn(
      "flex h-4.5 w-4.5 items-center justify-center rounded-full border-2 border-white bg-tertiary text-yellow-400",
      props.class,
    )}
  >
    <i class="ph-fill ph-lock-simple text-[10px]" aria-hidden="true" />
  </span>
);
